import { Typography, Box, Container } from "@mui/material";




export default function Contacts() {
    return(
        <Container>
            <Box sx={{
                display: "flex",
                flexWrap: "wrap",
                margin: "auto",
                marginTop: 16,
                p: 5,
                justifyItems: "center",
                width: {md: "100%", xs: "100%"},
                border: "1px solid",
                borderColor: "divider",
                borderRadius: "10px",
        }}>
            <Typography
                variant="h6"
                sx={{ 
                    mb: 2,
                    fontSize: "1.2rem"
                 }}
                >
                Contacts
            </Typography>

            <Typography  sx={{
                whiteSpace: "normal", 
        }}>

        


            </Typography>
        </Box>
    </Container>
        
        
    )
}